const schema = {
  data: {
    columns: [
      {
        title: 'task_name',
        data: 'name',
        fieldId: 'name',
        type: 'text',
        filterFormat: 'text',
        searchable: true,
        orderable: true,
        visible: true,
        default: true,
        pattern: null,
        originalType: 'text',
      },
      {
        title: 'status',
        data: 'status',
        fieldId: 'status',
        type: 'dropdownlist',
        filterFormat: 'dropdownlist',
        list: {
          created: 'created',
          processing: 'processing',
          success: 'success',
          failed: 'failed',
          aborted: 'aborted',
        },
        searchable: true,
        orderable: true,
        visible: true,
        default: true,
        multiple: false,
        multiselect: false,
        pattern: null,
        originalType: 'text',
      },
      {
        title: 'success_count',
        data: 'successCount',
        fieldId: 'successCount',
        type: 'number',
        filterFormat: 'number_interval',
        searchable: false,
        orderable: false,
        visible: true,
        default: true,
        originalType: 'number',
      },
      {
        title: 'failed_count',
        data: 'failedCount',
        fieldId: 'failedCount',
        type: 'number',
        filterFormat: 'number_interval',
        searchable: false,
        orderable: false,
        visible: true,
        default: true,
        originalType: 'number',
      },
      {
        title: 'instance_count',
        data: 'instanceCount',
        fieldId: 'instanceCount',
        type: 'number',
        filterFormat: 'number_interval',
        searchable: false,
        orderable: false,
        visible: true,
        default: true,
        originalType: 'number',
      },
      {
        title: 'result',
        data: 'result',
        fieldId: 'result',
        type: 'text',
        filterFormat: 'text',
        searchable: false,
        orderable: false,
        visible: true,
        default: true,
        originalType: 'text',
      },
      {
        title: 'created_by',
        data: 'createdBy',
        fieldId: 'createdBy',
        type: 'dropdownlist',
        filterFormat: 'dropdownlist',
        searchable: false,
        orderable: true,
        visible: true,
        default: true,
        multiselect: false,
        pattern: null,
        originalType: 'text',
      },
      {
        title: 'created_at',
        data: 'createdAt',
        fieldId: 'createdAt',
        type: 'datetime-local',
        filterFormat: 'datetime_interval',
        searchable: true,
        orderable: true,
        visible: true,
        default: true,
        pattern: '',
      },
    ],
    buttons: {},
    primaryInList: 'correlationId',
    aggregateColumn: {},
    primaryKey: 'ID_CORRELATION_ID',
    processActions: [],
    availableInDetailView: ['name', 'status', 'successCount', 'failedCount', 'instanceCount', 'createdAt', 'result'],
    availableInList: ['name', 'status', 'createdAt'],
    showInList: ['name', 'status', 'createdAt'],
  },
}

export { schema }
